<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container class="registration">
        <v-app-bar app flat height="79px">
            <a class="logo d-none d-sm-flex ma-sm-3">
                <v-img class="logo d-none d-sm-flex ma-sm-3" src="../assets/logo-plus.png" width="60px"></v-img>
            </a>
        </v-app-bar>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        {{ $t('registration.complete_your_userinfo') }}
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="userName"
                                        :label="`${labelUserNameField}*`" 
                                        required 
                                        outlined
                                        clearable
                                        :error-messages="errorMessagesUserNameField"
                                        counter
                                        maxlength="20"
                                    ></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field
                                        v-model="password"
                                        :label="`${labelCodeField}*`"
                                        required 
                                        outlined
                                        clearable
                                        :error-messages="errorMessagesCodeField"
                                        counter
                                        maxlength="4"
                                        @keypress="onlyNumber"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="name"
                                        :label="`${labelFirstNameField}*`" 
                                        required 
                                        outlined
                                        clearable
                                        :error-messages="errorMessagesFirstNameField"
                                        counter
                                        maxlength="20"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="surname"
                                        :label="`${labelLastNameField}*`" 
                                        required 
                                        outlined
                                        clearable
                                        :error-messages="errorMessagesLastNameField"
                                        counter
                                        maxlength="20"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                            <v-btn
                                color="green darken-1"
                                text
                                @click="saveUser"
                            >
                                {{ $t('registration.save') }}
                            </v-btn>                    
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col>
                <v-card>
                    <v-card-title>
                        {{ $t('registration.your_userinfo') }}
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-card>
                                    <v-card-subtitle>{{ $t('registration.email_address') }}</v-card-subtitle>
                                    <v-divider></v-divider>
                                    <v-card-text>{{ user.email }}</v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12">
                                <v-card>
                                    <v-card-subtitle>{{ $t('registration.country_code') }}</v-card-subtitle>
                                    <v-divider></v-divider>
                                    <v-card-text>{{ user.operationCountryCode }}</v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12">
                                <v-card>
                                    <v-card-subtitle>{{ $t('registration.postal_code') }}</v-card-subtitle>
                                    <v-divider></v-divider>
                                    <v-card-text>{{ user.operationPostalCode }}</v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12">
                                <v-card>
                                    <v-card-subtitle>{{ $t('registration.place') }}</v-card-subtitle>
                                    <v-divider></v-divider>
                                    <v-card-text>{{ user.operationPlace }}</v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12">
                                <v-card>
                                    <v-card-subtitle>{{ $t('registration.street') }}</v-card-subtitle>
                                    <v-divider></v-divider>
                                    <v-card-text>{{ user.operationStreet }}</v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-footer id="nav" color="#fff">
            <v-container>
                <div class="d-flex align-center justify-space-between footer-box">
                    <a class="logo">
                        <v-img src="../assets/logo-plus.png" width="60px"></v-img>
                    </a>

                    <!-- <div class="d-flex align-center footer-menu">
                        <router-link :to="{name:'help'}">{{ $t('help') }}</router-link>
                        <router-link :to="{name:'faq'}">{{ $t('faq') }}</router-link>
                        <router-link :to="{name:'about'}">{{ $t('about') }}</router-link>
                    </div> -->

                    <v-spacer></v-spacer>

                    <div class="copyright-footer">
                        &copy; {{ $t('copyright', {currentYear: this.$store.state.currentYear}) }}<span>|</span>
                        <router-link :to="{name:'help'}">{{ $t('disclaimer') }}</router-link><span>|</span>
                        <router-link :to="{name:'help'}">{{ $t('privacy_policy') }}</router-link>
                    </div>
                </div>
            </v-container>
        </v-footer>
    </v-container>
</template>

<script>
import config from '../config'
import Axios from 'axios'
import router from '@/router'
import { i18n } from '@/plugins/i18n'
const qs = require('querystring')

export default {
    data () {
        return {
            paramStr: '',
            labelUserNameField: this.$i18n.t('registration.username'),
            errorMessagesUserNameField: '',
            labelCodeField: this.$i18n.t('registration.code'),
            errorMessagesCodeField: '',
            labelFirstNameField: this.$i18n.t('registration.first_name'),
            errorMessagesFirstNameField: '',
            labelLastNameField: this.$i18n.t('registration.last_name'),
            errorMessagesLastNameField: '',
            user: {}
        }
    },
    created() {
        let $this = this
        this.paramStr = this.$route.params.id

        Axios.get(config.apiBaseUrl + 'api/employee/signing-user?EncryptGuid='+this.paramStr, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
        )
        .then(function (response) {
            if(response.status === 200) {
                $this.user = response.data
            }
        })
        .catch(function (error) {
            /* eslint-disable */
            console.log(error)
        })   
    },
    computed: {
        userName: {
            get(){
                return this.user.userName;
            },
            set(v) {
                this.user.userName = v;
            }
        },
        password: {
            get(){
                return this.user.password;
            },
            set(v) {
                this.user.password = v;
            }
        },
        name: {
            get(){
                return this.user.name;
            },
            set(v) {
                this.user.name = v;
            }
        },
        surname: {
            get(){
                return this.user.surname;
            },
            set(v) {
                this.user.surname = v;
            }
        },
    },
    methods: {
        onlyNumber($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) || keyCode === 46 || keyCode === 192) { // 46 is dot
                this.errorMessagesCodeField = this.$i18n.t('enterOnlyNumbers')
                $event.preventDefault()
            }
        },
        saveUser(e) {
            e.preventDefault()
            let $this = this;
            this.errorMessagesUserNameField = ''
            this.errorMessagesCodeField = ''
            this.errorMessagesFirstNameField = ''
            this.errorMessagesLastNameField = ''

            let errorsCount = 0;

            if(this.user.userName.length === 0) {
                this.errorMessagesUserNameField = this.$i18n.t('field_is_required')
                errorsCount++;
            }

            if(this.user.password.length === 0) {
                this.errorMessagesCodeField = this.$i18n.t('field_is_required')
                errorsCount++;
            }

            if(this.user.name.length === 0) {
                this.errorMessagesFirstNameField = this.$i18n.t('field_is_required')
                errorsCount++;
            }

            if(this.user.surname.length === 0) {
                this.errorMessagesLastNameField = this.$i18n.t('field_is_required')
                errorsCount++;
            }

            if(errorsCount !== 0) return

            Axios.post(config.apiBaseUrl + 'api/employee/edit-signing-user', qs.stringify($this.user), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
            )
            .then(function (response) {
                if(response.status === 200) {
                    let redirectPath = '/' + i18n.locale
                    router.push(redirectPath) 
                }
            })
            .catch(function (error) {
                /* eslint-disable */
                alert(error.response.data)
            })          
        }
    },
    watch: {
        userName() {
            this.errorMessagesUserNameField = '';
        },
        password() {
            this.errorMessagesCodeField = '';
        },
        name() {
            this.errorMessagesFirstNameField = '';
        },
        surname() {
            this.errorMessagesLastNameField = '';
        },
    },
}
</script>